module.exports = __webpack_public_path__ + "static/media/Loader-small.2da93b23.svg";